// Funnel page loaders - webinar, newsletter, and purchase flow pages
// These wrapper functions import and execute the actual loaders

export const webinarDetailsLoader = async (args: any) => {
    const module = await import("../pages/funnel/after-optin/webinar/webinarDetailsLoader");
    return module.webinarDetailsLoader ? await (module.webinarDetailsLoader as any)(args) : null;
};

export const sessionIdLoader = async (args: any) => {
    const module = await import("../util/TrackingUtil");
    return module.sessionIdLoader ? await (module.sessionIdLoader as any)(args) : null;
};

export const individualKedOfferLoader = async (args: any) => {
    const module = await import("../pages/user/learning-course/LearningCoursePurchasePage");
    return module.loader ? await (module.loader as any)(args) : null;
};

export const extraordinarySupportPurchaseLoader = async (args: any) => {
    const module = await import("../pages/user/extraordinary-support/ExtraordinarySupportPurchasePage");
    return module.loader ? await (module.loader as any)(args) : null;
};

export const parentPaymentLoader = async (args: any) => {
    const module = await import("../pages/ParentPaymentPage");
    return module.parentPaymentLoader ? await (module.parentPaymentLoader as any)(args) : null;
};

export const znPurchaseLoader = async (args: any) => {
    const module = await import("../pages/funnel/after-optin/zn/ZnPurchasePage");
    return module.loader ? await (module.loader as any)(args) : null;
};

export const platformUpsellLoader = async (args: any) => {
    const module = await import("../pages/funnel/PlatformUpsellPage");
    return module.loader ? await (module.loader as any)(args) : null;
};